<template>
    <div>
      <autoLogout />
      <loader v-if="loader" />
      <div class="wrapper-content">
        <encabezado
          :elementos="encabezado"
          :paramsRoute="paramsRoute"
          :nameRoute="nameRoute"
          v-if="showAction(1)"
        />
        <v-card v-if="showAction(1)" :class="[list.length < 6 ? 'calendar' : '']">
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="list"
              :search="search"
              :items-per-page="10"
              :footer-props="{
                'items-per-page-text': 'Elementos por página',
                'items-per-page-all-text': 'Todo',
              }"
              no-results-text="Sin resultados coincidentes con la búsqueda"
              loading-text="Cargando..."
              no-data-text="Sin resultados disponibles"
              dense
              fixed-header
              height="auto"
            >
              <template v-slot:top>
                <div class="row">
                  <branch-offices-list
                    :classOfDiv="cols"
                    style="padding-top: 22px"
                    :model="idBranchOfficeSelected"
                    v-on:triggerChange="branchOfficeSelected"
                  />
  
                  <div v-if="isViewAdmin()" class="col-md-2 col-xl-2 col-sm-12">
                    <div style="padding-top: 9px">
                      <v-autocomplete
                        v-model="modalitiesSelect"
                        :items="modalities"
                        item-text="name"
                        item-value="idModality"
                        auto-select-first
                        clearable
                        label="Modalidad"
                        @change="filterModality()"
                        no-data-text="Sin resultados disponibles"
                      />
                    </div>
                  </div>
                  <div v-if="isViewAdmin()" class="col-md-2 col-xl-2 col-sm-12">
                    <div style="padding-top: 9px">
                      <v-autocomplete
                        v-model="studyProfileSelect"
                        :items="studyProfileList"
                        item-text="name"
                        item-value="idStudyModality"
                        auto-select-first
                        clearable
                        label="Perfil de estudio"
                        @change="listAll()"
                        no-data-text="Sin resultados disponibles"
                      />
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-2">
                    <div
                      class="text-right pl-5"
                      id="handCalendar"
                      style="padding-top: 9px"
                    >
                      <vc-date-picker
                        color="green"
                        v-model="date"
                        :max-date="new Date()"
                        is-range
                      >
                        <template v-slot="{ inputEvents }">
                          <div class="flex justify-center items-center">
                            <v-text-field
                              v-on="inputEvents.start"
                              :value="dateCompuded"
                              label="Seleccione fecha"
                              :append-icon="
                                validData ? 'mdi-eraser' : 'mdi-calendar'
                              "
                              @click:append="clearCalendar"
                              :disabled-input="validData"
                            ></v-text-field>
                          </div>
                        </template>
                      </vc-date-picker>
                    </div>
                  </div>
                  <div class="col">
                    <v-text-field
                      v-model="search"
                      style="padding-top: 22px"
                      label="Buscar"
                      :append-icon="search ? 'mdi-eraser' : 'mdi-magnify'"
                      @click:append="search = ''"
                    ></v-text-field>
                  </div>
                </div>
              </template>
  
              <template v-slot:[`item.actions`]="{ item }">
                <v-tooltip
                  top
                  v-if="
                    (speciality == 3 &&
                      $utilFront.withPermission($prm.LABORATORY_STARTS)) ||
                    (speciality == 2 &&
                      $utilFront.withPermission($prm.IMAGE_STARTS))
                  "
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon @click="checkStudy(item)" :disabled="sending">
                      <v-icon color="success" v-bind="attrs" v-on="on">
                        mdi-play
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Comenzar</span>
                </v-tooltip>
  
                <v-tooltip
                  top
                  v-if="
                    (speciality == 3 &&
                      $utilFront.withPermission($prm.LABORATORY_CANCEL)) ||
                      (speciality == 2 && (
                      $utilFront.withPermission($prm.IMAGE_CANCEL) || 
                      ($utilFront.withPermission($prm.IMAGE_CANCEL_PAP_NURSE))
                    ))"
                      >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon @click="checkCancel(item)" :disabled="sending">
                      <v-icon color="error" v-bind="attrs" v-on="on">
                        mdi-stop
                      </v-icon>
                    </v-btn> 
                  </template>
                  <span>Cancelar</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
        <encabezado :elementos="titleStudyDetails" v-if="showAction(2)" />
        <v-card v-if="showAction(2)">
          <v-card-text>
            <v-row v-if="studyInfo && studyInfo.idPatient" class="mt-2">
              <v-col cols="12" md="12" sm="12" align="left">
                <patient-information :model="studyInfo" />
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <PatientInterpretationAppoInfo :model="studyInfo" />
              </v-col>
            </v-row>
  
            <v-row dense class="mt-6 mb-4 ">
              <v-col cols="12" sm="12" md="12">
                <v-banner
                  color="blue-grey lighten-5"
                  class="br black--text"
                  shaped
                  single-line
                >
                  Signos vitales
                </v-banner>
              </v-col>
              <v-col cols="4" v-for="(input, index) in vitalSign" :key="index">
                <strong> {{ input.label }} </strong>
                <span> {{ input.value }} {{ input.suffix }} </span>
              </v-col>
            </v-row>
  
            <v-row v-for="(item, i) in pathologicals" :key="i">
              <v-col cols="12" sm="12" md="12">
                <v-banner
                  color="blue-grey lighten-5"
                  class="br black--text"
                  shaped
                  single-line
                >
                {{ item.name }}
                </v-banner>
              </v-col>
              <v-col v-for="(question, n) in item.questions" :key="n">
                <p>{{ question.answer }}</p>
              </v-col>
            </v-row>
  
            <v-row v-for="(item, i) in heredoFamiliar" :key="'A' + i">
              <v-col cols="12" sm="12" md="12">
                <v-banner
                  color="blue-grey lighten-5"
                  class="br black--text"
                  shaped
                  single-line
                >
                {{ item.name }}
                </v-banner>
              </v-col>
              <v-col v-for="(question, n) in item.questions" :key="'A' + n">
                <p>{{ question.answer }}</p>
              </v-col>
            </v-row>
  
            <v-row>
              <v-col>
                <h3 class="font-weight-black mb-5">Diagnóstico</h3>
              </v-col>
            </v-row>
  
            <v-row>
              <v-col>
                <p
                  v-for="(diagnostic, index) in studyInfo.cie10List"
                  :key="index"
                >
                  {{ diagnostic }}
                </p>
              </v-col>
            </v-row>
  
            <v-row>
              <v-col>
                <h3 class="font-weight-black mb-5">Detalles de diagnóstico</h3>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                @click.right.prevent
                @copy.prevent
                @paste.prevent
                ondrop="return false;"
              >
                <v-textarea
                  outlined
                  auto-grow
                  disabled
                  row="1"
                  :value="studyInfo.diagnosticDetails"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-card-text>
  
          <v-card-actions class="text-center">
            <v-col>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="error"
                    text
                    v-bind="attrs"
                    v-on="on"
                    @click="confirmCancelation = true"
                  >
                    Cancelar estudio <v-icon right>mdi-stop</v-icon>
                  </v-btn>
                </template>
                <span>Cancelar estudio</span>
              </v-tooltip>
            </v-col>
            <v-col class="text-center">
              <v-btn color="error" plain class="mb-4" @click="changeAction(1)"
                ><v-icon left>mdi-chevron-left</v-icon>Volver
              </v-btn>
            </v-col>
            <v-col>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="primary"
                    v-bind="attrs"
                    v-on="on"
                    @click="beginStudy(studyInfo.idStudy)"
                  >
                    Iniciar estudio <v-icon right>mdi-play</v-icon>
                  </v-btn>
                </template>
                <span>Iniciar estudio</span>
              </v-tooltip>
            </v-col>
          </v-card-actions>
        </v-card>
  
        <v-dialog v-model="dialog" persistent max-width="60%" v-if="dialog">
          <v-card>
            <v-card-title class="text-h6 text-center success--text">
              ¿Desea iniciar este estudio?
            </v-card-title>
            <validation-observer ref="observer" v-slot="{ invalid }">
              <v-card-text>
                <v-container dense>
                  <v-row dense v-if="dataModal && dataModal.idPatient">
                    <v-col cols="12" md="12" sm="12">
                      <patient-information :model="dataModal" />
                    </v-col>
                    <v-col cols="12" md="12" sm="12">
                      <PatientInterpretationAppoInfo :model="dataModal" />
                    </v-col>
                  </v-row>
                  <v-row dense class="text-center mt-10 mb-8" v-if="dataModal.idModality !== 'MPAP-01'">
                    <v-col>
                      <h2 class="font-weight-black primary--text">
                        <strong>
                          Accession Number:
                          {{ dataModal.accessionNumber }}</strong
                        >
                      </h2>
                    </v-col>
                  </v-row>
                  
                  <v-row
    dense
    justify="center"
    class="mt-6"
    v-if="dataModal.idModality === 'MCOLP-01' || dataModal.idModality === 'MPAP-01'"
  >
    <v-col cols="12" md="6" sm="12" class="text-center">
      <!-- BOTÓN PARA INFORMACIÓN DE CONSULTA -->
      <v-btn
        color="info"
        large
        class="white--text font-weight-bold"
        @click="openInfoConsulta(dataModal)"
      >
        Información de consulta
        <v-icon right>mdi-information</v-icon>
      </v-btn>
  
      <!-- FORMULARIO DE COLPOSCOPIA -->
      
  
      <v-dialog v-model="dialogInfoConsulta" max-width="60%">
    <v-card>
      <v-card-title class="text-h6 font-weight-bold px-9">
    Información de consulta
  </v-card-title>
  
  
      <v-card-text>
        <v-container dense>
  
         
          <v-row>
            <v-col cols="12">
              <v-banner
                shaped
                single-line
                class="white--text mb-4"
                style="background-color: #60845c;"
              >
               
                Signos vitales
              </v-banner>
            </v-col>
          </v-row>
  
          <v-row>
            <v-col
              cols="4"
              v-for="(vs, index) in vitalSignConsulta"
              :key="index"
            >
              <v-text-field
                :label="vs.label"
                :value="vs.value"
                :suffix="vs.suffix"
                disabled
                dense
              />
            </v-col>
          </v-row>
  
          <v-row class="mt-6">
            <v-col cols="12">
              <v-banner
                shaped
                single-line
                class="white--text mb-4"
                style="background-color: #60845c;"
              >
               
                Antecedentes Patológicos
              </v-banner>
            </v-col>
          </v-row>
  
          <v-expansion-panels multiple class="mb-4">
            <v-expansion-panel
              v-for="(item, index) in pathologicalsConsulta"
              :key="'pat-'+index"
            >
              <v-expansion-panel-header>
                {{ item.name }}
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row>
    <v-col
      v-for="(question, i) in item.questions"
      :key="'patQ-'+i"
    >
      <v-textarea
        outlined
        readonly
        :value="question.answer"
        rows="2"
        class="mb-2"
      />
    </v-col>
  </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
  
          <v-expansion-panels multiple class="mb-4" >
            <v-expansion-panel
              v-for="(item, index) in heredoFamiliarConsulta"
              :key="'hf-'+index"
            >
              <v-expansion-panel-header>
                {{ item.name }}
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row>
    <v-col
      v-for="(question, i) in item.questions"
      :key="'patQ-'+i"
    >
      <v-textarea
        outlined
        readonly
        :value="question.answer"
        rows="2"
        class="mb-2"
      />
    </v-col>
  </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
  
          <v-expansion-panels multiple v-if="dataModal.sexPatient === 'Femenino'">
            <v-expansion-panel
              v-for="(item, index) in gynecologicalConsulta"
              :key="'gyQ-' + index"
            >
              <v-expansion-panel-header>
                {{ item.name }}
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row dense>
                  <v-col cols="4">
                    <div
                      v-for="(q, idx) in item.questions.slice(0, 5)"
                      :key="'gyColA-' + idx"
                    >
                      <strong>{{ q.name }}:</strong> {{ q.answer }}
                    </div>
                  </v-col>
                  <v-col cols="4">
                    <div
                      v-for="(q, idx) in item.questions.slice(5, 10)"
                      :key="'gyColB-' + idx"
                    >
                      <strong>{{ q.name }}:</strong> {{ q.answer }}
                    </div>
                  </v-col>
                  <v-col cols="4">
                    <div
                      v-for="(q, idx) in item.questions.slice(10, 15)"
                      :key="'gyColC-' + idx"
                    >
                      <strong>{{ q.name }}:</strong> {{ q.answer }}
                    </div>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
  
          <v-row class="mt-6">
            <v-col cols="12">
              <v-banner
                shaped
                single-line
                class="white--text mb-4"
                style="background-color: #60845c;"
              >
               
                Diagnóstico
              </v-banner>
            </v-col>
          </v-row>
  
          <v-row>
            <v-col cols="12">
              <v-autocomplete
                v-model="cieSelectedConsulta"
                :items="cieConsulta"
                item-text="text"
                item-value="value"
                multiple
                chips
                disabled
                label="Diagnóstico"
                no-data-text="Sin resultados"
              />
            </v-col>
          </v-row>
  
          <v-row align="center" justify="center" class="mt-4">
            <v-col cols="12" md="8" sm="12">
              <span>Detalles de diagnóstico</span>
              <v-textarea
                v-model="diagnosticDetailsConsulta"
                solo
                outlined
                dense
                readonly
                disabled
              />
            </v-col>
          </v-row>
  
        </v-container>
      </v-card-text>
  
      <v-card-actions class="text-center">
        <v-col>
          <v-btn color="error" text @click="dialogInfoConsulta = false">
            <v-icon left>mdi-chevron-left</v-icon> Volver
          </v-btn>
        </v-col>
      </v-card-actions>
    </v-card>
  </v-dialog>
    </v-col>
  </v-row>
  
        <v-row dense justify="start" class="mt-6" v-if="dataModal.idModality === 'MCOLP-01' || dataModal.idModality === 'MPAP-01'">
    <v-col cols="12">
      <v-banner
        shaped
        single-line
        class="white--text mb-4"
        style="background-color: #60845c;"
      >
        <v-icon class="white--text" left>mdi-alert</v-icon>
        Factores de riesgo para el Cáncer de cuello uterino
      </v-banner>
    </v-col>
  
    <v-col cols="12">
      <v-container class="pl-0 pr-0" fluid>
        <v-row
          dense
          v-for="(question, idxQ) in colposcopyQuestions"
          :key="question.idQuestion"
           v-if="showQuestion(question)"
          class="mb-3"
        >
          <v-col cols="8" class="text-left pl-0">
            <span class="font-weight-bold">{{ question.name }}</span>
          </v-col>
  
          <v-col cols="4" class="text-left">
            <template
              v-if="question.typeAnswer === 2 && question.answers && question.answers.length"
            >
              <v-radio-group
                v-model="question.idAnswer"
                row
                dense
                @change="onAnswerChange(question)"
              >
                <v-radio
                  v-for="(ans, iAns) in question.answers"
                  :key="ans.idAnswer"
                  :label="ans.name"
                  :value="ans.idAnswer"
                />
              </v-radio-group>
            </template>
  
            <template v-else-if="question.idQuestion === 'QGIN-09'">
    <v-menu
      v-model="question.menuOpen"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      max-width="280"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-bind="attrs"
          v-on="on"
          label="Fecha de estudio citológico"
          :value="formatDDMMYYYY(question.answerOpen)"
          readonly
          dense
        />
      </template>
  
      <v-date-picker
    v-model="question.answerOpen"
    scrollable
    :allowed-dates="onlyPast"
    @input="question.menuOpen = false"
  />
    </v-menu>
  </template>
  
          </v-col>
        </v-row>
      </v-container>
    </v-col>
        </v-row >


  <v-row class="mt-6" v-if="dataModal.idModality === 'MPAP-01'">
  <v-col cols="12">
   <h3>Observaciones</h3>
  </v-col>
  <v-col cols="12">
    <validation-provider
      v-slot="{ errors }"
      name="Observaciones"
      rules="required"
    >
      <v-textarea
        v-model="observation"
        outlined
        auto-grow
        :error-messages="errors"
        label="Observaciones"
        rows="6"
        class="mb-4"
      />
    </validation-provider>
  </v-col>
</v-row>    
  
                  <v-row
                    dense
                    class="mt-8 mb-4"
                    justify="center"
                    v-if="viewHistoryMammography"
                  >
                    <v-col cols="12" sm="12" md="12" class="mb-4">
                      <v-banner
                        color="blue-grey lighten-5"
                        class="mb-4 black--text"
                        shaped
                        single-line
                      >
                        Antecedentes de mastografía
                      </v-banner>
                    </v-col>
  
                    <v-col cols="4" md="4" sm="12">
                      <v-text-field
                        v-model.trim="historyMammography.dateStudy"
                        label="Fecha de última mastografía*"
                        required
                        autocomplete="off"
                        dense
                        :max="new Date().toISOString().split('T')[0]"
                        :clear-icon="$cnst.CLEAR_ICON"
                        clearable
                        type="date"
                      />
                    </v-col>
                    <v-col cols="4" md="4" sm="12">
                      <v-autocomplete
                        v-model="historyMammography.idBirads"
                        :items="listBirads"
                        item-text="text"
                        item-value="idBirads"
                        auto-select-first
                        clearable
                        label="BI-RADS"
                        dense
                        :clear-icon="$cnst.CLEAR_ICON"
                        no-data-text="Sin resultados disponibles"
                      />
                    </v-col>
                  </v-row>
                 
  
                </v-container>
              </v-card-text>
  
              <v-card-actions class="text-center">
                <v-col>
                  <v-btn color="error" plain @click="cancelAction()">
                    <v-icon left>mdi-chevron-left</v-icon> volver
                  </v-btn>
                </v-col>
                <v-col v-if="speciality == 2 || speciality == 3">
                  <v-btn
                    color="primary"
                    :disabled="isButtonDisabled"
                    @click="beginStudy(dataModal.idStudy)"
                  >
                    Iniciar estudio <v-icon right>mdi-play</v-icon>
                  </v-btn>
                </v-col>
              </v-card-actions>
            </validation-observer>
          </v-card>
        </v-dialog>
  
        <v-dialog v-model="dialog2" persistent max-width="60%" v-if="dialog2">
          <v-card>
            <v-card-title class="text-h6 text-center error--text">
              ¿Desea cancelar este estudio?
            </v-card-title>
  
            <validation-observer ref="observer" v-slot="{ invalid }">
              <v-card-text>
                <v-container>
                  <v-row dense>
                    <v-col cols="12" md="12" sm="12">
                      <patient-information :model="dataModal" />
                    </v-col>
                    <v-col cols="12" md="12" sm="12">
                      <PatientInterpretationAppoInfo :model="dataModal" />
                    </v-col>
                  </v-row>
  
                  <v-row dense class="text-center mt-10" v-if="speciality == 2">
                    <v-col>
                      <h2 class="font-weight-black primary--text">
                        <strong>
                          Accession Number:
                          {{ dataModal.accessionNumber }}</strong
                        >
                      </h2>
                    </v-col>
                  </v-row>
  
                  <v-row>
                    <v-col>
                      <h3 class="font-weight-black mt-5">Motivo</h3>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-form ref="form" v-model="valid" lazy-validation>
                        <v-row>
                          <v-col
                            @click.right.prevent
                            @copy.prevent
                            @paste.prevent
                            ondrop="return false;"
                          >
                            <validation-provider
                              v-slot="{ errors }"
                              name="Motivo"
                              rules="required|min:6"
                            >
                              <v-textarea
                                outlined
                                v-model="reason"
                                :value="reason"
                                :error-messages="errors"
                                label="Motivo de cancelación"
                                id="cancellation"
                                required
                              ></v-textarea>
                            </validation-provider>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
  
              <v-card-actions class="text-center">
                <v-col>
                  <v-btn color="error" plain @click="closeCancel()">
                    <v-icon left>mdi-chevron-left</v-icon> volver
                  </v-btn>
                </v-col>
                <v-col>
                  <v-btn
                    :disabled="sending || invalid"
                    color="primary"
                    @click="cancelStudy(dataModal.idStudy)"
                  >
                    Cancelar estudio <v-icon right>mdi-stop</v-icon>
                  </v-btn>
                </v-col>
              </v-card-actions>
            </validation-observer>
          </v-card>
        </v-dialog>
  
        <v-dialog v-model="confirmCancelation" persistent max-width="600" eager>
          <v-card>
            <v-card-title> Confirmar cancelación de estudio </v-card-title>
            <validation-observer ref="confirmCancelation" v-slot="{ invalid }">
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col>
                      <p>
                        Para confirmar la cancelación del estudio
                        <span class="font-weight-black">
                          {{ studyInfo.idStudy }}</span
                        >
                        deberá ingresar un motivo de cancelación
                      </p>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      @click.right.prevent
                      @copy.prevent
                      @paste.prevent
                      ondrop="return false;"
                    >
                      <validation-provider
                        v-slot="{ errors }"
                        name="Motivo de cancelación"
                        rules="required"
                      >
                        <v-textarea
                          v-model="reason"
                          label="Motivo de cancelación"
                          outlined
                          auto-grow
                          required
                          :error-messages="errors"
                        ></v-textarea>
                      </validation-provider>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions class="text-center d-flex flex-column">
                <v-col>
                  <v-btn
                    color="error"
                    :loading="sending"
                    :disabled="invalid || sending"
                    @click="cancelStudy(studyInfo.idStudy)"
                  >
                    Cancelar estudio
                    <template v-slot:loader>
                      <span>Cancelando...</span>
                    </template>
                    <v-icon right>mdi-stop</v-icon>
                  </v-btn>
                </v-col>
                <v-col>
                  <v-btn plain small color="error" @click="closeConfirmDialog()">
                    <v-icon left>mdi-chevron-left</v-icon>
                    Volver
                  </v-btn>
                </v-col>
              </v-card-actions>
            </validation-observer>
          </v-card>
        </v-dialog>
      </div>
    </div>
  </template>
  <script>
  import moment from "moment";
  import Datatable from "../components/Datatable.vue";
  import Encabezado from "@/app/components/base/header/Header.vue";
  import Sidebar from "../components/Sidebar";
  import BtnAccion from "../components/btnAccion.vue";
  import {
    StudyRequest,
    ReportPDFRequest,
    ModaltyRequest,
    VitalSignRequest,
    EvaluationRequest,
    StudyModalityRequest,
    BiradsRequest,
    MedicalPracticeRequest,
    ColposcopyForm,
  } from "@/core/request";
  import { UtilFront } from "@/core";
  import { mapActions } from "vuex";
  import AutoLogout from "../components/AutoLogout.vue";
  
  import { extend, ValidationObserver, ValidationProvider } from "vee-validate";
  import BranchOfficesList from "../components/BranchOfficesList.vue";
  import Loader from "../components/Loader.vue";
  
  import PatientInformation from "@/app/components/common/patient/PatientInformation.vue";
  import PatientInterpretationAppoInfo from "@/app/components/interpretation/PatientInterpretationAppoInfo.vue";
  
  export default {
    name: "IniciarEstudio",
    components: {
      PatientInformation,
      PatientInterpretationAppoInfo,
      Sidebar,
      Encabezado,
      Datatable,
      BtnAccion,
      AutoLogout,
      ValidationObserver,
      ValidationProvider,
      BranchOfficesList,
      Loader,
    },
    data() {
      return {
        historyMammography: {},
        viewHistoryMammography: false,
        listBirads: [],
        loader: true,
        paramsRoute: {},
        prevRoute: null,
        acronym: "TD",
        dialog: false,
        dialog2: false,
        dialog3: false,
        sending: false,
        search: "",
        dataModal: {},
        dialogInfoConsulta: false,
        colposcopyQuestions: [],
        reason: "",
        observation: "",
        modalities: [],
        studyProfileList: [],
        modalitiesSelect: [],
        studyProfileSelect: null,
        reasonRules: [(v) => !!v || "El motivo de la cancelación es obligatorio"],
        speciality: "",
        encabezado: { icono: "mdi-play", texto: "Comenzar Estudio" },
        quantityRules: [
          (v) => !!v || "La cantidad de etiquetas es obligatorio",
          (v) => (v && v > 0) || "La cantidad de etiquetas es obligatorio",
        ],
        list: [],
        headers: [
          { text: "Id Estudio", value: "idStudy", align: "center" },
          { text: "Id Paciente", value: "idPatient", align: "center" },
          {
            text: "Nombre del paciente",
            value: "fullNamePatient",
            align: "center",
          },
          { text: "Modalidad", value: "nameModality", align: "center" },
          { text: "Estudio", value: "nameStudy", align: "center" },
          {
            text: "Fecha y hora de solicitud",
            value: "registrationDate",
            align: "center",
          },
          {
            text: "Acciones",
            value: "actions",
            sortable: false,
            align: "center",
          },
        ],
        btnCloseStudy: {
          route: "",
          icon: "mdi-folder-lock",
          text: "",
          tooltip: "",
        },
        btnPending: {
          route:
            this.speciality == 2
              ? "/imagen/historial"
              : "/laboratorio/interpretacion/pendientes",
          icon: "mdi-clock-alert-outline",
          text: "Historial de estudios",
          tooltip: "Historial de estudios",
        },
        service: StudyRequest,
        valid: false,
        idBranchOfficeSelected: null,
        cols: "col-md-2 col-xl-2 col-sm-12",
        date: "",
  
        //Study Details
        titleStudyDetails: {
          icono: "mdi-text-box-search",
          texto: "Detalles del estudio",
        },
        studyInfo: {},
        vitalSign: [],
        vitalSignConsulta: [],
        pathologicalsConsulta: [],
        heredoFamiliarConsulta: [],
        gynecologicalConsulta: [],
        cieSelected: [],          
      cie: [],                 
      cieSelectedConsulta: [],    
      cieConsulta: [],            
      diagnosticDetailsConsulta: "",
      diagnosticDetails: "",
      today: new Date().toISOString().split("T")[0], 
        /* pathologicals: [],
        heredoFamiliar: [],
        gynecological: [], */
        confirmCancelation: false,
        action: 1,
      };
    },
    computed: {
      nameRoute: function () {
        if (this.$utilFront.getRole() == "Químico" && this.speciality == 3) {
          return "IniciarEstudio2";
        } else if (
          this.$utilFront.getRole() == "Radiólogo" &&
          this.speciality == 2
        ) {
          return "IniciarEstudio1";
        }
        return;
      },
      dateCompuded() {
        if (this.date == "" || this.date == null || this.date == undefined) {
          return "";
        }
        return `${moment(this.date.start).format("DD/MM/YYYY")} al ${moment(
          this.date.end
        ).format("DD/MM/YYYY")}`;
      },
      validData() {
        if (this.date == "" || this.date == null || this.date == undefined) {
          return false;
        }
        this.listAll();
        return true;
      },
        
  requiresQuestionValidation() {
    const studyName = this.dataModal?.nameStudy;
    const requires = studyName === "COLPOSCOPIA" || studyName === "PAPANICOLAOU";
    return requires;
  },
  
  isButtonDisabled() {   
    if (this.sending || this.invalid) {
      return true;
    }
    
    if (this.requiresQuestionValidation) {
      const allAnswered = this.allQuestionsAnswered;
      return !allAnswered;
    }
    
    return false;
  },
  
  allQuestionsAnswered() {
    
    if (!this.requiresQuestionValidation) {
      return true;
    }
    
    if (!this.colposcopyQuestions?.length) {
      return true;
    }

    const visibleQs = this.colposcopyQuestions.filter(q => this.showQuestion(q));

    const allAnswered = visibleQs.every(q => {
      let answered = false;
      if (q.typeAnswer === 2) {
        answered = !!q.idAnswer;
      } else if (q.typeAnswer === 1 || q.idQuestion === "QGIN-09") {
        answered = !!q.answerOpen;
      } else {
        answered = true;
      }
      
      return answered;
    });
    
    return allAnswered;
  }
    },
    created() {
      let speciality1 = localStorage.getItem("speciality");
      this.speciality = this.$route.params.speciality;
  
      if (this.speciality == undefined || this.speciality == "") {
        this.speciality = speciality1;
        if (this.$utilFront.isEmpty(speciality1)) {
          if (this.$route.path.includes("imagen")) {
            this.speciality = 2;
          } else if (this.$route.path.includes("laboratorio")) {
            this.speciality = 3;
          } else {
            this.speciality = 2;
          }
        }
      } else {
        localStorage.setItem("speciality", this.speciality);
      }
      if (this.speciality == 3) {
        this.headers = [
          { text: "Id Estudio", value: "idStudy", align: "center" },
          { text: "Id Paciente", value: "idPatient", align: "center" },
          {
            text: "Nombre del paciente",
            value: "fullNamePatient",
            align: "center",
          },
          { text: "Modalidad", value: "nameModality", align: "center" },
          { text: "Estudio", value: "nameStudy", align: "center" },
          {
            text: "Fecha y hora de solicitud",
            value: "registrationDate",
            align: "center",
          },
          {
            text: "Acciones",
            value: "actions",
            sortable: false,
            align: "center",
          },
        ];
      }
      this.listAllModalities();
      this.listAllStudiesProfile();
      this.modalitiesSelect = this.modalities.slice();
    },
    mounted() {
      this.validBrowserTab();
      this.btnCloseStudy.route =
        this.speciality == 2 ? "/imagen/cerrar" : "/laboratorio/validar";
  
      this.btnPending.route =
        this.speciality == 2
          ? "/imagen/historial"
          : "/laboratorio/interpretacion/pendientes";
  
      this.validateData();
  
      this.listAll();
      this.listAllBirads();
    },
    watch: {
      speciality(val) {
        if (this.speciality == 2) {
          this.btnCloseStudy = {
            route: "/imagen/cerrar",
            icon: "mdi-folder-lock",
            text: "Estudios por cerrar",
            tooltip: "Estudios por cerrar",
          };
        } else {
          this.btnCloseStudy = {
            route: "/laboratorio/validar",
            icon: "mdi-folder-lock",
            text: "Estudios por validar",
            tooltip: "Estudios por validar",
          };
        }
      },
    },
    methods: {
      ...mapActions(["validTab", "unauthorized"]),
      validBrowserTab() {
        this.validTab();
      },
      catchError: (e) => {
        // console.log(e);
        // this.$utilFront.notifications("Ha ocurrido un error interno", "ERROR");
      },
      changeAction(action) {
        if (action == 1) {
          this.action = action;
          this.listAll();
        } else if (action == 2) {
          this.action = action;
        }
      },
      showAction(action) {
        return this.action == action;
      },
      clearCalendar() {
        this.date = "";
        this.listAll();
      },
      listAllBirads() {
        this.listBirads = [];
        BiradsRequest.listAll().then((res) => {
          let { data, code } = res.data;
          if (code == 200 && Array.isArray(data)) {
            this.listBirads = data.map((obj) => {
              return {
                text: obj.name,
                idBirads: obj.idBirads,
              };
            }).filter((item)=> item.text != 'NA');
          }
        });
      },
      listAllModalities() {
        let post = {
          idSpeciality: this.speciality,
        };
        ModaltyRequest.listModaltyByHumanResourceAndSpecialty(post).then(
          (res) => {
            if (res.data.code === 200 && res.data.status === "OK") {
              this.modalities = res.data.data.map((modality) => {
                return {
                  idModality: modality.idModality,
                  name: modality.acronym + " - " + modality.name,
                  speciality: modality.speciality || "--- Sin información ---",
                  acronym: modality.acronym,
                };
              });
              // this.modalitiesSelect = res.data.data.map((modality) => {
              //   return {
              //     idModality: modality.idModality,
              //   };
              // });
            } else if (res.data.code === 401) {
              this.unauthorized();
            } else {
              this.modalities = [];
            }
          }
        );
      },
      listAllStudiesProfile() {
        if (!this.loader) {
          this.loader = true;
        }
  
        let idModality = UtilFront.nonEmpty(this.modalitiesSelect)
          ? this.modalitiesSelect
          : null;
        StudyModalityRequest.listStudyModalityBySpecialityAndUser(
          this.speciality,
          idModality
        )
          .then((res) => {
            let studyprofile = res.data.data;
            this.studyProfileList = studyprofile;
          })
          .catch((e) => {
            console.log(e);
          })
          .finally(() => {
            this.loader = false;
          });
      },
      listAll() {
        this.loader = true;
        let modalityPost = null;
        let studiePost = null;
        if (
          UtilFront.nonEmpty(this.modalitiesSelect) &&
          this.modalitiesSelect.length != null
        ) {
          modalityPost = [this.modalitiesSelect];
        } else {
          modalityPost = null;
        }
        if (UtilFront.nonEmpty(this.studyProfileSelect)) {
          studiePost = this.studyProfileSelect;
        } else {
          studiePost = null;
        }
  
        let postStatus = {
          status: 1,
          speciality: this.speciality,
          idBranchOffice:
            this.idBranchOfficeSelected != null
              ? this.idBranchOfficeSelected
              : UtilFront.getIdBranchOffice(),
          modalities: modalityPost,
          idStudyModality: studiePost
        };
  
        if (this.$utilFront.nonEmpty(this.date)) {           
          postStatus.startDate = this.$utilFront.startOfDay(this.date.start);           
          postStatus.finishDate = this.$utilFront.endOfDay(this.date.end);         
        }
  
        StudyRequest.listAllByStatus(postStatus).then((res) => {
          if (res.data.code === 200 && res.data.status === "OK") {
            let data = res.data.data;
            if (data) {
              data.sort(function (a, b) {
                return (
                  new Date(a.registrationDate) - new Date(b.registrationDate)
                );
              });
            }
            this.list = data.map((study) => {
              let sex;
              if (study.gender === "H") {
                sex = "Masculino";
              } else if (study.gender === "M") {
                sex = "Femenino";
              } else if (study.gender === "X") {
                sex = "No binario";
              }
              return {
                idStudy: study.idStudy,
                accessionNumber: study.accessionNumber,
                idPatient: study.idPatient,
                idModality: study.idModality,
                fullNamePatient: study.patient || "---",
                nameModality: study.modality || "---",
                nameStudy: study.studyModality || "---",
                registrationDate:
                  moment(new Date(study.registrationDate))
                    .locale("es")
                    .format("DD/MM/YYYY HH:mm") || "---",
                nacPatient:
                  moment(new Date(study.birthDate))
                    .locale("es")
                    .format("DD/MM/YYYY") || "---",
                // sexPatient: study.gender === "H" ? "Masculino" : "Femenino",
                sexPatient: sex,
                idPerson: study.idPerson,
                laboratoryLabel: UtilFront.nonEmpty(study.laboratoryLabel)
                  ? study.laboratoryLabel
                  : study.accessionNumber,
              };
            });
          } else if (res.data.code === 401) {
            this.unauthorized();
          }
          this.loader = false;
        });
      },
      
      openInfoConsulta(item) {
      this.dataModal = Object.assign({}, item);
  
      let mpPromise = this.getMedicalPracticeInfoConsulta(item.idStudy);
  
      let vsPromise = VitalSignRequest.findAllByPatientOrStudyOrMedicalPractice({
        idStudy: item.idStudy,
      }).then((res) => {
        if (res.data.code === 200 && res.data.status === "OK") {
          this.vitalSignConsulta = res.data.data.map((v) => ({
            label: v.vitalSignType.name,
            value: v.description,
            suffix: v.vitalSignType.suffix,
          }));
        }
      });
  
      let antPromise = this.getAntecedentsForModal(item.idPerson);
  
      Promise.all([mpPromise, vsPromise, antPromise])
        .finally(() => {
          this.dialogInfoConsulta = true;
        });
    },
  
  getAntecedentsForModal(idPerson) {
    EvaluationRequest.listByPersonAndType({ type: 2, idPerson })
      .then((res) => {
        if (res.data.response) {
          this.pathologicalsConsulta = res.data.data;
        }
      })
      .finally(() => {
        EvaluationRequest.listByPersonAndType({ type: 3, idPerson })
          .then((res) => {
            if (res.data.response) {
              this.heredoFamiliarConsulta = res.data.data;
            }
          })
          .finally(() => {
            EvaluationRequest.listByPersonAndType({ type: 4, idPerson })
              .then((res) => {
                if (res.data.response) {
                  this.gynecologicalConsulta = res.data.data;
                }
              })
              .finally(() => {
                this.dialogInfoConsulta = true;
              });
          });
      });
  },
  
  getMedicalPracticeInfoConsulta(idStudy) {
      const token = localStorage.getItem("token");
  
      return MedicalPracticeRequest.listMedicalPracticeDetails(
        { idStudy },
        { headers: { Authorization: token } }
      ).then((res) => {
        if (res.data.code === 200 && res.data.status === "OK") {
          const data = res.data.data;
  
          // Llenar diagnóstico
          this.cieSelectedConsulta = data.cie10.map((c) => c.cie10.idCIE10);
          this.cieConsulta = data.cie10.map((c) => ({
            text: c.cie10.key + " - " + c.cie10.name,
            value: c.cie10.idCIE10,
          }));
  
          // Detalles de diagnóstico
          this.diagnosticDetailsConsulta =
            data.diagnosticPersonInfo?.diagnosticDetails || "";
        } else if (res.data.code === 401) {
          this.unauthorized();
        } else {
          console.warn("Error al obtener información de MedicalPractice:", res.data);
        }
      });
    },
  checkStudy(item) {
    if (this.speciality == 2) {
        this.dataModal = Object.assign(this.dataModal, item);
        this.dataModal.quantity = 1;
        this.historyMammography = {};
        let { nameStudy, nameModality } = this.dataModal;
        this.viewHistoryMammography =
          this.$cnst.IS_MOMMOGRAPHY(nameStudy) ||
          this.$cnst.IS_MOMMOGRAPHY(nameModality);
  
      ColposcopyForm.getColposcopyForm({
        evaluationTypes: [12],
        idPerson: item.idPerson,
        idStudy: item.idStudy
      })
        .then((res) => {
  
          if (Array.isArray(res.data) && res.data.length) {
            const colpoData = res.data[0];
  
            this.isEdit = colpoData?.dataQuestions?.some(
              (q) => q.idAnswer || q.answerClosed || q.answerOpen
            );
            
            this.colposcopyCalculatorId = colpoData.idCalculator;
  
            this.colposcopyQuestions = colpoData.dataQuestions.map((q) => {
              let answerOpen = "";
  
              if (q.idQuestion === "QGIN-09" && q.answerClosed) {
                const fechaMoment = moment(q.answerClosed, "YYYY-MM-DD HH:mm:ss");
                if (fechaMoment.isValid()) {
                  answerOpen = fechaMoment.format("YYYY-MM-DD");
                }
              } else if (q.typeAnswer === 1) {
                answerOpen = q.openAnswers || "";
              }
  
              return {
                ...q,
                answerOpen,
                menuOpen: false, 
              };
            });
          } else {
            this.isEdit = false;
          }
        })
        .catch((err) => {
          console.error("Error al consumir getColposcopyForm =>", err);
        });
  
      this.dialog = true;
    } else {
      this.getStudyDetails(item);
    }
  },
  
  
  onAnswerChange(question) {
      if (question.idQuestion === "DV-15") {
        this.$forceUpdate(); 
      }
    },
    showQuestion(question) {
    if (["QGIN-09", "QGIN-10"].includes(question.idQuestion)) {
      const q8 = this.colposcopyQuestions.find(q => q.idQuestion === "QGIN-08");
      if (q8?.idAnswer !== "AGIN-15") {
        return false;
      }
    }
    return true;
  },
    /* areAllQuestionsAnswered() {
      if (!this.colposcopyQuestions?.length) return true;
      return this.colposcopyQuestions.every((q) => {
        if (q.typeAnswer === 2) {
          return !!q.idAnswer;
        } else if (q.typeAnswer === 1 || q.idQuestion === 'DV-17') {
          return !!q.answerOpen;
        }
        return true;
      });
    }, */
  beginStudy(study) {
    if (!this.loader) {
      this.dialog = false;
      this.loader = true;
      this.sending = true;
  
      try {
        const colposcopyPayload = {
          calculators: [
            {
              idCalculator: this.colposcopyCalculatorId,
              dataQuestions: this.colposcopyQuestions.map((q) => {
                if (q.typeAnswer === 2) {
                  return { idQuestion: q.idQuestion, idAnswer: q.idAnswer };
                } else if (q.typeAnswer === 1 || q.idQuestion === "QGIN-09") {
                  return { idQuestion: q.idQuestion, openAnswer: q.answerOpen };
                }
                return { idQuestion: q.idQuestion };
              }),
            },
          ],
          idPerson: this.dataModal.idPerson,
        };
  
        const colposcopyAction = this.isEdit
          ? ColposcopyForm.editColposcopyForm(colposcopyPayload)
          : ColposcopyForm.saveColposcopyForm(colposcopyPayload);
  
        colposcopyAction
          .then((resp) => {
            if (resp.status === 200) {
              let postID = {
                idStudy: study,
                appointment: { speciality: this.speciality },
                historyMammography: this.historyMammography,
              };
  
              const dateStudy = postID.historyMammography?.dateStudy;
              if (dateStudy) {
                postID.historyMammography.dateStudy =
                  this.$utilFront.endOfDay(dateStudy);
              }
              if (this.dataModal.idModality === "MPAP-01") {
                  postID.observation = this.observation;
              } else {
                  postID.observation = null;
              }
  
              return StudyRequest.beginStudy(postID);
            } else {
              throw new Error("Error al guardar/editar colposcopia");
            }
          })
          .then((res) => {
            if (res.data.data) {
              if (res.data.code === 200 && res.data.status === "OK") {
                if (this.speciality == 3) {
                  this.downloadBarcode(study);
                }
                this.$utilFront.notifications(
                  "Estudio iniciado correctamente",
                  "SUCCESS"
                );
                this.changeAction(1);
              } else if (res.data.code === 401) {
                this.unauthorized();
              } else {
                this.$utilFront.notifications(
                  "Sucedió un error al iniciar el estudio",
                  "ERROR"
                );
              }
            }
          })
          .catch((err) => {
            console.error("** colposcopyAction ERROR =>", err);
            this.$utilFront.notifications(
              err.message || "Error al guardar/editar colposcopia",
              "ERROR"
            );
          })
          .finally(() => {
            this.listAll();
            this.sending = false;
            this.loader = false;
            this.dataModal = {};
          });
      } catch (e) {
        this.catchError(e);
      }
    }
  },
  
    formatDDMMYYYY(isoString) {
      if (!isoString) return "";
      return moment(isoString, "YYYY-MM-DD").format("DD/MM/YYYY");
    },
  
    onlyPast(dateString) {
    const picked = moment(dateString, 'YYYY-MM-DD');
    return picked.isSameOrBefore(moment(), 'day');
  },
  
  
      checkDetail(item) {
        localStorage.setItem("idStudy", item.idStudy);
        localStorage.setItem("speciality", this.speciality);
        if (this.speciality == 2) {
          this.$router.push({
            name: "DetalleEstudio1",
            params: this.paramsRoute,
          });
        } else if (this.speciality == 3) {
          this.$router.push({
            name: "DetalleEstudio2",
            // params: { idStudy: item.idStudy },
            params: this.paramsRoute,
          });
        }
      },
      checkCancel(item) {
        this.dataModal = {};
        this.dataModal = Object.assign(this.dataModal, item);
        if (this.$utilFront.isNonNull(this.dataModal)) {
          this.dataModal.quantity = 1;
          this.dialog2 = true;
        }
      },
      validateData() {
        // this.paramsRoute = this.$route.params;
        // let data = this.$route.params;
  
        let ls = JSON.parse(localStorage.getItem("modality")) || {};
        let data = ls;
  
        let nameModality = "Todas";
        this.acronym = "TD";
        if (!(typeof data.acronym === "undefined")) {
          nameModality = data.title;
          this.acronym = data.acronym;
        }
        this.encabezado.texto = "Comenzar estudio > " + nameModality;
      },
  
      dialogTag(item) {
        this.dialog3 = true;
        this.tagModal = item;
        this.tagModal.quantity = 1;
      },
  
      downloadBarcode(study) {
        this.sending = true;
        try {
          let data = {
            idStudy: study,
            fileName: "Codigo de barras",
            quantityTags: 1,
          };
          ReportPDFRequest.downloadBarcodeLaboratory(data);
        } catch (e) {
          this.catchError(e);
        } finally {
          this.sending = false;
        }
      },
      closeCancel() {
        this.$refs.form.reset();
        this.$refs.observer.reset();
        this.dialog2 = false;
        this.dataModal = {};
        this.reason = "";
      },
      cancelAction() {
        this.dialog = false;
        this.dataModal = {};
      },
      isViewAdmin() {
        return UtilFront.isViewAdmin();
      },
      branchOfficeSelected(selected) {
        this.idBranchOfficeSelected = selected;
        // this.listAllModalities();
        this.listAll();
      },
  
      getStudyDetails(item) {
        this.loader = true;
        let postData = {
          idStudy: item.idStudy,
        };
        let idPatient = item.idPatient;
        let idPerson = item.idPerson;
        StudyRequest.getStudy(postData)
          .then((res) => {
            const { data, code, status } = res.data;
            if (code == 200 && status === "OK") {
              const studyInfo = data;
              let objStudyInfo = {
                idSpeciality: studyInfo.idSpeciality,
                idPatient: studyInfo.idPatient,
                idStudy: studyInfo.idStudy,
                fullNamePatient: studyInfo.fullNamePatient,
                gender: studyInfo.sexPatient,
                curp: studyInfo.curpPatient,
                phone: studyInfo.phoneNumber,
                homePhone: studyInfo.homePhone,
                studyModality: studyInfo.nameStudy,
                modality: studyInfo.nameModality,
                status: studyInfo.status,
                accessionNumber: studyInfo.accessionNumber,
                registrationDate: this.$utilFront.formatDate(
                  studyInfo.registrationDateStudy
                ),
                birthdatePatient: this.$utilFront.formatDate(studyInfo.birthDate),
                gender: studyInfo.sexPatient,
                age: this.$utilFront.obtainAgeWithLabel(studyInfo.birthDate),
                // this.$utilFront.obtainAge(studyInfo.birthDate),
                diagnosticDetails: studyInfo.diagnosticDetails,
                cie10List: studyInfo.cie10List,
                laboratoryLabel: studyInfo.laboratoryLabel,
              };
  
              this.studyInfo = objStudyInfo;
              this.changeAction(2);
            }
          })
          .then(() => {
            this.getVitalSignByPatient(item.idStudy);
          })
          .then(() => {
            this.getAntecentsByPerson(idPerson);
          });
      },
  
       getVitalSignByPatient(idStudy) {
        this.loader = true;
  
        VitalSignRequest.findAllByPatientOrStudyOrMedicalPractice({
          idStudy: idStudy,
        })
          .then((res) => {
            const { data, code, status } = res.data;
  
            if (code == 200 && status == "OK") {
              this.vitalSign = data.map((vital) => {
                let type = "";
                if (vital.vitalSignType.type === 1) {
                  type = "number";
                } else if (vital.vitalSignType.type === 2) {
                  type = "text";
                }
                let required = 0;
                if (vital.vitalSignType.required === 1) {
                  required = true;
                } else if (vital.vitalSignType.required === 2) {
                  required = false;
                }
  
                return {
                  idVitalSignType: vital.vitalSignType.idVitalSignType,
                  type: type,
                  label: vital.vitalSignType.name,
                  suffix: vital.vitalSignType.suffix,
                  status: vital.vitalSignType.status,
                  required: required,
                  value: vital.description,
                  idVitalSigns: vital.idVitalSigns,
                };
              });
            } else if (code == 401) {
              this.unauthorized();
            }
          })
          .finally(() => {
            this.loader = false;
          });
      }, 
  
       getAntecentsByPerson(idPerson) {
        this.loader = true;
        this.pathologicals = [];
  
        let postData = {
          type: 2,
          idPerson: idPerson,
        };
  
        EvaluationRequest.listByPersonAndType(postData)
          .then((res) => {
            let { data, response, message } = res.data;
  
            if (response) {
              this.pathologicals = data;
            }
          })
          .then(() => {
            this.heredoFamiliar = [];
            let postData = {
              type: 3,
              idPerson: idPerson,
            };
            EvaluationRequest.listByPersonAndType(postData).then((res) => {
              let { data, response, message } = res.data;
              if (response) {
                this.heredoFamiliar = data;
              }
            });
          })
          .then(() => {
            this.gynecological = [];
            let postData = {
              type: 4,
              idPerson: idPerson,
            };
            EvaluationRequest.listByPersonAndType(postData).then((res) => {
              let { data, response, message } = res.data;
              if (response) {
                this.gynecological = data;
              }
            });
          })
          .finally(() => {
            this.loader = false;
          });
      }, 
  
      closeConfirmDialog() {
        if (this.confirmCancelation) {
          this.reason = "";
          this.$refs.confirmCancelation.reset();
          this.confirmCancelation = false;
        }
      },
  
      cancelStudy(idStudy) {
        this.sending = true;
        this.loading = true;
  
        let postData = {
          reason: this.reason,
          study: {
            idStudy: idStudy,
          },
        };
  
        StudyRequest.cancelStudy(postData)
          .then((res) => {
            const { data, code, status } = res.data;
  
            if (code == 200 && status == "OK") {
              this.$utilFront.notifications(
                "Estudio cancelado correctamente",
                "SUCCESS"
              );
              this.closeConfirmDialog();
              this.studyInfo = {};
              this.sending = false;
              this.changeAction(1);
            } else {
              this.$utilFront.notifications(
                "Error al cancelar el estudio, intente nuevamente",
                "ERROR"
              );
            }
          })
          .finally(() => {
            this.sending = false;
            this.loader = false;
            this.closeCancel();
            this.listAll();
          });
      },
      filterModality() {
        this.studyProfileSelect = null;
        this.listAllStudiesProfile();
        this.listAll();
      },
    },
  };
  </script>
  